import baseApi from './baseApi';

const publicAccessApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    sendCallPermission: build.mutation({
      query: (props: { clientId: string }) => ({
        url: `/clients/call-permission/${props.clientId}`,
        method: 'POST',
      }),
    }),
    initiateCall: build.mutation({
      query: (props: { clientId: string; sdp: string }) => ({
        url: `/clients/initiate-call/${props.clientId}`,
        method: 'POST',
        body: { sdp: props.sdp },
      }),
    }),
    terminateCall: build.mutation({
      query: (props: { clientId: string }) => ({
        url: `/clients/terminate-call/${props.clientId}`,
        method: 'POST',
      }),
    }),
    getCallAudioUploadUrl: build.mutation<
      { uploadUrl: string; fileName: string; callId: number },
      { clientId: string }
    >({
      query: (props: { clientId: string }) => ({
        url: `/clients/get-call-audio-upload-url/${props.clientId}`,
        method: 'POST',
      }),
      transformResponse: (response: { uploadUrl: string; fileName: string; callId: number }) => response,
    }),
  }),
  overrideExisting: false,
});

export const {
  useSendCallPermissionMutation,
  useInitiateCallMutation,
  useTerminateCallMutation,
  useGetCallAudioUploadUrlMutation,
} = publicAccessApi;
